import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Proforma } from 'models/ProformaModel';


const ProformaList: React.FC = () => {
  const width = { sno: 10, client:24, amount: 12, segment:12, status:12,  date: 12, createdby: 12 }
  const [formId, formName] = [Code.Form.Id.PROFORMA, Code.Form.Name.PROFORMA];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [proformaData, setProformaData] = useState<Proforma[]>([]); 
  const [selectedProforma, setselectedProforma] = useState<Proforma | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, rows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const PrivClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.Proforma.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Proforma.Number, 
        Name.Proforma.Date, 
        Name.Client.FullName, 
        Name.Client.Id,
        Name.Proforma.Net,
        Name.Common.SegmentName,
        Name.Common.StatusName,
        Name.User.FullName,
        Name.Sale.Id
      ]),
      user_id: userId,
      location_id: locationId,
    });
    await API.Data.List<Proforma>(url, setProformaData, setError, setLoading); 
 }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.User} options={userOptions} onChange={setUserId} />
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, proformaData, setSelectAllChecked,formName)} extra={3} />
              <Control.Grid.Items values={[
                [Title.ProformaNo, width.sno], 
                [Title.ClientName, width.client], 
                [Title.Amount, width.amount, Code.Align.RIGHT],
                [Title.Date, width.date],
                [Title.Segment, width.segment],
                [Title.State, width.status],
                [Title.CreatedBy, width.createdby]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(proformaData) && (
              <Control.Grid.Row>
                {proformaData.map((proformaData) => { return (
                  <Control.Grid.Data<Proforma> key={proformaData.proforma_id} itemKey={proformaData.proforma_key} data={proformaData} setMenuPosition={setMenuPosition} setSelectedData={setselectedProforma} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={proformaData.proforma_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, proformaData.proforma_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Print path={Utility.Join.Print(Privilege, formName, proformaData.proforma_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Sale path={Utility.Join.Edit(Privilege, Code.Form.Name.SALE, proformaData.sale_id)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Text value={proformaData.proforma_number} width={width.sno} />
                    <Control.Grid.Link value={Utility.Get.FullName(proformaData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PrivClient, Code.Form.Name.CLIENT, proformaData.client_id)} width={width.client} iframeRef={iframeRef}  />
                    <Control.Grid.Items values={[
                      [Utility.Format.Amount(proformaData.proforma_net_amount), width.amount, Code.Align.RIGHT],
                      [Utility.Format.DateOnly(proformaData.proforma_date), width.date], 
                      [proformaData.segment_name, width.segment], 
                      [proformaData.status_name, width.status], 
                      [Utility.Get.FullName(proformaData,Code.Form.Name.USER), width.createdby], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={proformaData.proforma_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={proformaData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedProforma?.proforma_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedProforma?.proforma_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ProformaList;